import { Component } from '@angular/core';

@Component({
  selector: 'app-save-svg',
  standalone: true,
  template: `
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1130_10542"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1130_10542)">
        <path
          d="M16.5837 6.17621V15.2435C16.5837 15.6186 16.4541 15.9357 16.1951 16.1948C15.9361 16.4538 15.619 16.5833 15.2439 16.5833H4.75678C4.38164 16.5833 4.06456 16.4538 3.80553 16.1948C3.54651 15.9357 3.41699 15.6186 3.41699 15.2435V4.75642C3.41699 4.38128 3.54651 4.0642 3.80553 3.80517C4.06456 3.54614 4.38164 3.41663 4.75678 3.41663H13.8241L16.5837 6.17621ZM15.5003 6.62496L13.3753 4.49996H4.75678C4.68192 4.49996 4.62046 4.52399 4.57241 4.57204C4.52435 4.6201 4.50033 4.68156 4.50033 4.75642V15.2435C4.50033 15.3184 4.52435 15.3798 4.57241 15.4279C4.62046 15.4759 4.68192 15.5 4.75678 15.5H15.2439C15.3187 15.5 15.3802 15.4759 15.4282 15.4279C15.4763 15.3798 15.5003 15.3184 15.5003 15.2435V6.62496ZM10.0003 14.141C10.5078 14.141 10.9403 13.9623 11.2976 13.605C11.655 13.2476 11.8337 12.8152 11.8337 12.3077C11.8337 11.8002 11.655 11.3677 11.2976 11.0104C10.9403 10.653 10.5078 10.4743 10.0003 10.4743C9.49283 10.4743 9.0604 10.653 8.70303 11.0104C8.34567 11.3677 8.16699 11.8002 8.16699 12.3077C8.16699 12.8152 8.34567 13.2476 8.70303 13.605C9.0604 13.9623 9.49283 14.141 10.0003 14.141ZM5.82095 8.40371H12.1637V5.82058H5.82095V8.40371Z"
          fill="#EA5B0C"
        />
      </g>
    </svg>
  `,
})
export class SaveSvgComponent {}
